import EditorControls from './EditorControls';

export default EditorControls;
